import { render, staticRenderFns } from "./DeliverySettings.vue?vue&type=template&id=4b9af1f2"
import script from "./DeliverySettings.vue?vue&type=script&lang=js"
export * from "./DeliverySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports